import {Component, DestroyRef, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {select, Store} from '@ngrx/store';

import {Observable} from 'rxjs';


import {Authentication} from '@appModels/core-auth/auth/auth';

import * as fromReducer from '@appStore/reducers';
import * as fromSelectors from '@appStore/selectors';
import {Login} from '@appStore/actions/core-auth/auth/auth.actions';
import {UserService} from '@appServices/core-auth/user/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {AuthService} from '@appServices/core-auth/auth/auth.service';
import * as moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  // The risky obserable object might be used to show some msg in template
  risky$ = this.store.pipe(select(fromSelectors.isRisky));
  errMsg$ = this.store.pipe(select(fromSelectors.errMsg));
  lockTime = null;
  lockMessage = null;
  remainingTime = null;
  loading = false;
  ipAddress = null;

  auth$: Observable<Authentication>;
  currentYear: number;

  constructor(
    private store: Store<fromReducer.auth.State>,
    private renderer: Renderer2,
    private userService: UserService,
    private route: ActivatedRoute,
    public router: Router,
    private http:HttpClient,
    private authService:AuthService,
    private destroyRef: DestroyRef
  ) {
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'login_screen');
  }

  getIPAddress()
  {

    const headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    this.http.get("https://api.bigdatacloud.net/data/client-ip?key=963f0097847c4877831d4b5032d94dc2", { headers })
      .subscribe((result:any) => {
        if (result && result.ipString) this.ipAddress = result.ipString;
    }, _ => {});
  }

  ngOnInit() {
    this.checkIfLoginLocked();
    this.subscribeToErrorMessage();
    this.currentYear = moment().year()
    this.getIPAddress();
    this.renderer.addClass(document.body, 'login_screen');
    const loading$ = this.store.pipe(select(fromSelectors.getAuthLoading));
    loading$.subscribe(data => {
      this.loading = data;
    });
    this.route.queryParams.subscribe(params => {
      if (params.username) {
        // @TODO auth is required for process the user activation...
        this.userService.getUserByUsername(params.username).subscribe(data => {
          this.userService.updateUser({...data, enabled: true}).subscribe(result => {
            console.log('user enabled')
          })
        })
      }
      if (params.next) {
        localStorage.setItem('nextUrl', params.next);
      }
    });
  }

  // The form is submitted with the corresponding model type `Authentication`
  onSubmit(usernameEmailMobile, password) {
    this.store.dispatch(new Login({usernameEmailMobile: usernameEmailMobile, password}));
    console.log("Sent log in request")
    this.authService.saveLogInIp({usernameEmailMobile:usernameEmailMobile, password:password, ipAddress:this.ipAddress}).subscribe(response => {});

  }

  checkRedirect() {
    const redirectUrl = localStorage.getItem('redirectUrl')
    if ( redirectUrl !== null) {
         localStorage.removeItem('redirectUrl');
        return this.router.navigateByUrl(redirectUrl.split('/')[1])
    } else {
      return this.router.navigateByUrl('/home')
    }
  }

  subscribeToErrorMessage() {
    this.errMsg$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      if (data) {
        if (data.wrongAttempts == '3' || data.wrongAttempts == '5') {
          this.lockLoginAttempts(data.wrongAttempts, data.error);
        }
      }
    });
  }

  checkIfLoginLocked() {
    this.lockTime = localStorage.getItem('lockTime');
    this.lockMessage = localStorage.getItem('lockMessage');
    if (this.lockTime !== null) {
      this.showCountdown(this.lockTime);
    } else {
      this.remainingTime = null;
    }
  }

  showCountdown(lockTime) {
    const lockTimeDate = new Date(lockTime);
    let countdownInterval = null;
    const updateCountdown = () => {
      const now = new Date();
      const diff = lockTimeDate.getTime() - now.getTime();
      const minutes = Math.floor(diff / 1000 / 60);
      const seconds = Math.floor((diff / 1000) % 60);

      if (diff <= 0) {
        if (countdownInterval) {
          clearInterval(countdownInterval);
        }
        localStorage.removeItem('lockTime');
        localStorage.removeItem('lockMessage');
        this.remainingTime = null;
      } else {
        this.remainingTime = `${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`;
      }
    };

    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }

  lockLoginAttempts(wrongAttempts, lockMessage) {
    const lockoutMinutes = this.getLockoutMinutes(+wrongAttempts);
    const lockoutTime = moment().add(lockoutMinutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');
    localStorage.setItem('lockTime', lockoutTime);
    localStorage.setItem('lockMessage', lockMessage);
    this.showCountdown(localStorage.getItem('lockTime'));
    this.lockMessage = lockMessage;
  }

  getLockoutMinutes(wrongAttempts: number): number {
    switch (wrongAttempts) {
      case 3:
        return 5;
      case 5:
        return 15;
      default:
        return 0;
    }
  }
}

